import * as CookieConsent from 'vanilla-cookieconsent';
import { gsap, SplitText, CustomEase } from '../global/gsap';

const initSplash = (element) => {
    const header = document.querySelector('.js-header');
    const media = element.querySelector('.js-hero-media');
    const tagline = element.querySelector('.js-hero-tagline');
    const track = tagline.querySelector('.js-tagline-track');
    const heroFooter = element.querySelector('.js-hero-footer');

    const splashPlayed = sessionStorage.getItem('splashShown');
    const customEase = 'M0,0 C0.668,0 0.132,1 1,1';

    if (splashPlayed) {
        element.classList.add('finish');

        gsap.set([header, heroFooter, tagline], {
            opacity: 1
        });
    } else {
        gsap.set(media, {
            opacity: 0.4
        });

        gsap.set([header, heroFooter, tagline], {
            opacity: 0
        });

        const splashTl = gsap.timeline({
            defaults: {
                ease: CustomEase.create('custom', customEase),
            },
            onStart: () => {
                window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
                document.body.classList.add('stop-scrolling');
            },
            onComplete: () => {
                element.classList.add('finish');

                gsap.to([header, heroFooter], {
                    opacity: 1,
                    stagger: 0.25,
                    delay: 0.5,
                    onComplete: () => {
                        document.body.classList.remove('stop-scrolling');
                        sessionStorage.setItem('splashShown', true);

                        gsap.to(track, {
                            color: '#fff'
                        });

                        gsap.to(media, {
                            opacity: 0.7
                        });

                        // Check if cookie manager hasn't been responded to
                        if (!document.cookie.split(';').some((item) => item.trim().startsWith('cc_cookie='))) {
                            CookieConsent.show();
                        }
                    }
                });
            }
        });

        const split = new SplitText(tagline, { type: 'lines, words', linesClass: 'line' });

        gsap.set(split.words, {
            yPercent: 100,
            opacity: 0
        });

        gsap.set(tagline, {
            opacity: 1
        });

        let words = null;

        if (track) {
            words = track.querySelectorAll('.js-tagline-word');

            gsap.set(track, {
                color: '#fd7045'
            });
        }

        splashTl.to(split.words, {
            yPercent: 0,
            opacity: 1,
            stagger: 0.035,
            duration: 1
        });

        if (words && words.length > 0) {
            words.forEach((word, i) => {
                let delay = 0;

                // Negative delay on first word
                if (i === 0) {
                    delay = -0.5;
                }

                // Scroll first four words slowly
                if (i < 4) {
                    splashTl.to(track, {
                        y: `-${i}em`,
                        delay,
                        duration: 0.45
                    });
                // The rest
                } else if (i === 4) {
                    splashTl.to(track, {
                        y: `-${words.length - 1}em`,
                        duration: 0.9
                    });
                }
            });
        }
    }
};

export { initSplash as default };
